module.exports = __webpack_public_path__ + "static/PlayfairDisplayBold-f78a8c62bdf3c9c27b4fa485b8c3d279.ttf";